import Mediator from "../../utilities/Mediator";

var MediatorCalculated = {
	instance: function () {
		if (!MediatorCalculated.instance) {
			MediatorCalculated.instance = this;
		}
		return MediatorCalculated.instance;
	},

	calculateStep: null,
	tagsCreated: new Map(),
	targetOnline: "",
	targetDay: "",
	targetWeek: "",
	targetMonth: "",
	targetHarvest: "",

	notify(sender, event) {
		switch (event) {
			case "init-step":
				this.calculateStep = sender
				break;

			case "insert-element":
				sendToCalc(sender)
				updateStatusCreatedTags()
				break

			case "load-calc":
				insertCalc(sender)
				updateStatusCreatedTags()
				break

			case "clean-calculate":
				cleanCurrentAreaCalculate()
				updateStatusCreatedTags()
				break

			case "backspace-calculate":
				backspaceCalculate()
				updateStatusCreatedTags()
				break

			case "update-form":
				updateForm(sender)
				break
		}
	}
}

let keys = ["operation-0", "operation-1", "operation-2", "operation-3", "operation-4", "operation-5"]
let keysAreaDrag = ["calculation-area-online", "calculation-area-day", "calculation-area-week", "calculation-area-month", "calculation-area-harvest"]
let keyAgragateValues = ["targetOnline", "targetDay", "targetWeek", "targetMonth", "targetHarvest"]
let keysRelative = ["(", ")", "+", "-", "*", "/"]

function updateStatusCreatedTags() {
	function wasUsed(tag, sentence){
	  let values = sentence.split(" ")
	  let result = false
	  for (const token of values) {
		if(tag.trim() == token.split(":")[0].trim())
		  result = true
	  }
  
	  return result
	}
	MediatorCalculated.calculateStep.reloading = true
	MediatorCalculated.calculateStep.tagsCreated.forEach(t => {
	  let result = wasUsed(t.name, MediatorCalculated.targetOnline)
	  result = wasUsed(t.name, MediatorCalculated.targetDay) || result
	  result = wasUsed(t.name, MediatorCalculated.targetWeek) || result
	  result = wasUsed(t.name, MediatorCalculated.targetMonth) || result
	  result = wasUsed(t.name, MediatorCalculated.targetHarvest) || result
  
	  t.used = result
	})
  
	setTimeout(() => {
	  MediatorCalculated.calculateStep.reloading = false
	}, 70);
  }

function getAreaCalculateActive(){
	let index = MediatorCalculated.calculateStep.indexCalcType
	return keysAreaDrag[index]
}

function getAgregateValuesActive(){
	let index = MediatorCalculated.calculateStep.indexCalcType
	return keyAgragateValues[index]
}

function sendToCalc(name) {
	let tag = MediatorCalculated.tagsCreated.find(t => t.name == name)
	let tagToUpdate = MediatorCalculated.calculateStep.tagsCreated.find(t => t.name == name)

	if (!tag && check.insertOperation(name)) {
		let index = keys.indexOf(name)
		let keyRelative = keysRelative[index];
		createOperation(keyRelative)
		return
	}
	else if (tag && check.insertTag(tag)) {
		if(tag.type == 3 || tag.type == 4 || tag.type == 2)
			createTag(tag.name)
		else if(tag.type == 1)
			createTag(`${tag.name}:${tag.variables[0]}`)

		tag.used = true
		if(tagToUpdate){
			tagToUpdate.used = true
		}
	}
}

function insertCalc() {
	keyAgragateValues.forEach((agregate, index) => {
		if (!MediatorCalculated[agregate]) return;

		let calculate = MediatorCalculated[agregate].split(" ")
		let area = keysAreaDrag[index]
		document.getElementById(area).innerHTML = "";
		MediatorCalculated[agregate] = ""
	
		calculate.forEach(token => {
			if (keysRelative.includes(token)) {
				createOperation(token, area, agregate)
			}
			else if(token){
				createTag(token, area, agregate)
			}
		});
	})
}

var check = {
	getLastElement() {
		let agregate = getAgregateValuesActive()
		let agragateCalc = MediatorCalculated[agregate];
		var variables = agragateCalc.split(" ")
		return variables[variables.length - 1]
	},

	getRelativeTag(key) {
		let index = keys.indexOf(key)
		return keysRelative[index];
	},

	insertTag(tag) {
		let lastElement = this.getLastElement()
		let agregate = getAgregateValuesActive()
		let agragateCalc = MediatorCalculated[agregate]

		if (!agragateCalc) return true // Se estiver iniciando um calculo
		if (!keysRelative.includes(lastElement) || lastElement == ")") {
			this.emitError(`Cálculo inválido:`, tag.name)
			return false
		}
		return true
	},

	insertOperation(key) {
		let operations = ["+", "-", "*", "/"]
		let agregate = getAgregateValuesActive()
		let agregateCalc = MediatorCalculated[agregate];
		let step = ""
		let emit = (keyRelative, step) => {
			console.log('step ', step )
			this.emitError(`Cálculo inválido:`, keyRelative)
			return false
		}

		step = "Verifica a entrada incial de um operador inválido."
		if (!agregateCalc && key != "operation-0" && key != "operation-3"){
			console.log('step ', step )
			return false
		} 

		console.log('key', key)

		var variables = agregateCalc.split(" ")
		let lastElement = variables[variables.length - 1]
		let keyRelative = this.getRelativeTag(key)

		step = "bloquear: (+, (*, (/";
		if (lastElement == "(" && (key == "operation-2" || key == "operation-4" || key == "operation-5")) return emit(keyRelative, step)

		step = "Verifica a duplicidade de operadores"
		if (operations.includes(lastElement) && key != "operation-0" && key != "operation-1")  return emit(keyRelative, step)

		step = "Verificando parenteses com ultimo valor não sendo aritimético"
		if (!operations.includes(lastElement) && key == "operation-0" && lastElement != "(" && lastElement != "") return emit(keyRelative, step)

		step = "Verifica os quantidade de parenteses parenteses"
		let left_parentheses = variables.filter(t => t.includes("("))
		let rigth_parentheses = variables.filter(t => t.includes(")"))
		if(left_parentheses.length <= rigth_parentheses.length && key == "operation-1") return emit(keyRelative, step)

		step = "Verifica parenteses vazio"
		let empty_parentheses = false
		variables.forEach(t => {
			if(t == "(" && key == "operation-1")
				empty_parentheses = true

			if(t != "(" && empty_parentheses)
				empty_parentheses = false
		})

		if(empty_parentheses) return emit(keyRelative, step)

		return true
	},

	emitError(msg, keyRelative) {
		let area = getAgregateValuesActive()
		let calc = MediatorCalculated[area];
		MediatorCalculated.calculateStep.showError(`${msg} [${calc + ' ' + keyRelative}]`)
	}
}

function cleanCurrentAreaCalculate() {
	let key = getAreaCalculateActive()
	let calculate = getAgregateValuesActive()

	document.getElementById(key).innerHTML = "";
	MediatorCalculated[calculate] = "",
	MediatorCalculated.calculateStep.update()
}

function backspaceCalculate(){
	let calculate = getAgregateValuesActive()
	if(!MediatorCalculated[calculate]) return;

	let key = getAreaCalculateActive()
	let parent  = document.getElementById(key)
	let childrens = parent.childNodes
	parent.removeChild(childrens[childrens.length - 1])
	let teste = MediatorCalculated[calculate]
	let calc = MediatorCalculated[calculate].split("")
	calc.reverse()
	let indexStoped = 0
	for(let i in calc){
		if((calc[i] == " " || (calc.length - 1) == i) && indexStoped == 0)
			indexStoped = i
	}
	indexStoped++;
 	let newCalc = "";
	for(let i = 0; i < (teste.length - indexStoped); i++){
		newCalc += teste[i]
	}
	MediatorCalculated[calculate] = newCalc
	MediatorCalculated.calculateStep.update()
}

function createOperation(token, key, calculate) {
	let label = document.createElement("label")
	label.style["background-color"] = "#ff5b0080";
	setStyle(label)
	label.innerHTML = token;

	if(!key)
		key = getAreaCalculateActive()

	document.getElementById(key).appendChild(label)

	if(!calculate)
		calculate = getAgregateValuesActive()

	MediatorCalculated[calculate] += MediatorCalculated[calculate] ?  " " + token : token
	MediatorCalculated.calculateStep.update()
}

function createTag(tag, key, calculate) {
	let label = document.createElement("label")
	label.style["background-color"] = "#00a39f80";
	setStyle(label)
	label.innerHTML = tag;

	if(!key)
		key = getAreaCalculateActive()
	document.getElementById(key).appendChild(label)

	if(!calculate)
		calculate = getAgregateValuesActive()

	MediatorCalculated[calculate] += MediatorCalculated[calculate] ?  " " + tag : tag
	MediatorCalculated.calculateStep.update()
}

function setStyle(el) {
	el.style["min-width"] = "24px";
	el.style["text-align"] = "center";
	el.style["padding"] = "2px 6px";
	el.style["border"] = "1px solid #0001";
	el.style["border-radius"] = "4px";
	el.style["margin"] = "2px";
}

function updateForm(tag) {
	let tabs = document.querySelectorAll(".tabs>div>ul>li>a");
	if (tag.type == 3) {
		tabs[0].click()
		MediatorCalculated.calculateStep.mappingTag = tag.name;
		MediatorCalculated.calculateStep.mappingValue = tag.variables[0];
	}
    else if (tag.type == 4) {
		tabs[1].click()
        let value = Mediator.data.productionPlanItens.find(p => tag.name.includes(p.planTag))
		MediatorCalculated.calculateStep.productionPlanSelected = value
		MediatorCalculated.calculateStep.productionPlanTag = tag.name
	}
	else if (tag.type == 1) {
		tabs[2].click()
		MediatorCalculated.calculateStep.nameConstant = tag.name;
		MediatorCalculated.calculateStep.valueConstante = tag.variables[0]
	}
	else if (tag.type == 2) {
		tabs[3].click()
		MediatorCalculated.calculateStep.indicatorSelected = tag.key
		MediatorCalculated.calculateStep.indicatorValue = tag.name;
		MediatorCalculated.calculateStep.valueConstante = tag.variables[0]
	}
}

export default MediatorCalculated